import React, { useState, useEffect } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Button,
  Grid
} from '@mui/material';
import { format } from 'date-fns';
import api from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';

export default function Logs() {
  const { user, loading } = useAuth();
  console.log('user context:', user);
  console.log('loading context:', loading);
  const [logs, setLogs] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [filtros, setFiltros] = useState({ id_usuario: '', entidade: '', tipo_acao: '', dataInicio: '', dataFim: '' });

  // Verifica se o usuário atual é um administrador
  const isAdmin = user?.role === 'admin';
  console.log('isAdmin:', isAdmin, 'user?.role:', user?.role);

  useEffect(() => {
    if (!loading && isAdmin) {
      carregarUsuarios();
      carregarLogs();
    }
    // eslint-disable-next-line
  }, [loading, isAdmin]);

  const carregarLogs = async () => {
    try {
      const response = await api.get('/logs', { params: filtros });
      setLogs(response.data);
    } catch (error) {
      setLogs([]);
    }
  };

  const carregarUsuarios = async () => {
    try {
      const response = await api.get('/usuarios');
      setUsuarios(response.data);
    } catch (error) {
      setUsuarios([]);
    }
  };

  const handleFiltroChange = (e) => {
    setFiltros({ ...filtros, [e.target.name]: e.target.value });
  };

  const handleBuscar = () => {
    carregarLogs();
  };

  if (loading) {
    console.log('AuthContext still loading');
    return <div>Carregando...</div>;
  }

  if (!isAdmin) {
    console.log('Acesso negado para user:', user);
    return (
      <Box sx={{ p: { xs: 1, md: 2 }, pl: { xs: 1, md: 1.5 } }}>
        <Typography variant="h5" gutterBottom>
          Acesso Negado
        </Typography>
        <Typography variant="body1">
          Você não tem permissão para acessar esta página. Entre em contato com um administrador.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 1, md: 2 }, pl: { xs: 1, md: 1.5 } }}>
      <Typography variant="h5" gutterBottom>
        Histórico de Alterações do Sistema
      </Typography>

      <Paper style={{ padding: 16, marginBottom: 16 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <FormControl fullWidth>
              <InputLabel>Usuário</InputLabel>
              <Select
                name="id_usuario"
                value={filtros.id_usuario}
                onChange={handleFiltroChange}
                label="Usuário"
              >
                <MenuItem value="">Todos</MenuItem>
                {usuarios.map((u) => (
                  <MenuItem key={u.id} value={u.id}>{u.nome}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Entidade"
              name="entidade"
              value={filtros.entidade}
              onChange={handleFiltroChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <FormControl fullWidth>
              <InputLabel>Ação</InputLabel>
              <Select
                name="tipo_acao"
                value={filtros.tipo_acao}
                onChange={handleFiltroChange}
                label="Ação"
              >
                <MenuItem value="">Todas</MenuItem>
                <MenuItem value="criar">Criar</MenuItem>
                <MenuItem value="atualizar">Atualizar</MenuItem>
                <MenuItem value="excluir">Excluir</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              label="Data Início"
              name="dataInicio"
              type="date"
              value={filtros.dataInicio}
              onChange={handleFiltroChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              label="Data Fim"
              name="dataFim"
              type="date"
              value={filtros.dataFim}
              onChange={handleFiltroChange}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={12} style={{ textAlign: 'right' }}>
            <Button variant="contained" color="primary" onClick={handleBuscar}>
              Buscar
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Data/Hora</TableCell>
              <TableCell>Usuário</TableCell>
              <TableCell>Ação</TableCell>
              <TableCell>Entidade</TableCell>
              <TableCell>ID Entidade</TableCell>
              <TableCell>IP Origem</TableCell>
              <TableCell>Dados Novos</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map((log) => (
              <TableRow key={log.id}>
                <TableCell>{format(new Date(log.createdAt), 'dd/MM/yyyy HH:mm')}</TableCell>
                <TableCell>{log.usuario?.nome || '-'}</TableCell>
                <TableCell>{log.tipo_acao}</TableCell>
                <TableCell>{log.entidade}</TableCell>
                <TableCell>{log.id_entidade}</TableCell>
                <TableCell>{log.ip_origem || '-'}</TableCell>
                <TableCell>
                  <pre style={{ margin: 0, fontSize: 12, whiteSpace: 'pre-wrap' }}>
                    {log.dados_novos ? JSON.stringify(log.dados_novos, null, 2) : '-'}
                  </pre>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
